import React, { useEffect, useState } from 'react';
// import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import UnfoldMoreRoundedIcon from '@mui/icons-material/UnfoldMoreRounded';
import { InfoTooltip } from '../Tooltips';
import { TooltipCard } from '../Cards';

const TailoredRegionReDirectionPointer = React.memo(({
  lat,
  lng,
  rotate,
  tooltip,
  onClickHandler,
  onAnimationStart,
}: {
  lat: number;
  lng: number;
  rotate: boolean;
  tooltip: string;
  onClickHandler: () => void;
  onAnimationStart?: () => void;
}) => {

  useEffect(() => {
    onAnimationStart && onAnimationStart();    
  }, []);

  return (
    <InfoTooltip
      title={<TooltipCard content={tooltip} />}
    >
      <div
        style={{
          position: 'relative',
          width: '24px',
          height: '24px',
          borderRadius: 999,
          // transform: `translate(-50%, -50%) rotate(${rotate ? 90 - 45 : -45}deg)`,
          transform: `translate(-50%, -50%) rotate(${rotate ? 90 : 0}deg)`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mixBlendMode: 'multiply',
          backdropFilter: 'blur(4px)',
          cursor: 'pointer',
          fontSize: '28px'
        }}
        onClick={onClickHandler}
      >
        <div className="map-tailore-region-open-button" />
        <UnfoldMoreRoundedIcon fontSize={'inherit'} />
      </div>
    </InfoTooltip>
  );
});

export default TailoredRegionReDirectionPointer;
